/**
 * @file 路由
 * @author chenyuyang
 */
import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';

import {fetchUserInfo} from './actions/attestAction';

import Footer from './components/Footer/index';
import Attest from './pages/attest/index';
import AttestStep from './pages/attestStep';
import CompanyGuide from './pages/companyGuide';
import AppealMajor from './pages/appeal/appeal';
import MarkMajor from './pages/mark/mark';
import VerifyMsg from './pages/verifyMsg/verifyMsg';
import MarkErr from './pages/errorPage/markErr';
import NumErr from './pages/errorPage/numErr';
import ErrPage from './pages/errorPage/errPage';
import Help from './pages/help';
import Partner from './pages/partner';
import FeedbackMajor from './pages/feedback/feedback';
import YellowPage from './pages/yellowPage';
import UserCenter from './pages/userCenter';
import InfoAttest from './pages/infoAttest';
import InfoAppeal from './pages/infoAppeal';
import LocationPage from './pages/locationPage/index';
import InfoMark from './pages/infoMark';
import Demo from './pages/demo';
import CallAuth from './pages/callAuth/index';

import Header from './components/Header/index';
import NewBusinessCard from './pages/businessCard/newCard';
import PzCard from './pages/businessCard/pzCard';

// new haoma
import Home from './pages/newHome/index';
import NormalLandPage from './pages/normalLandPage/index';

import {clearLocalStorage} from './util';
import 'antd/dist/antd.css';

import './App.less';
export class App extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            conMinHeight: 0,
            hasLogin: false
        };
    }

    componentDidMount() {
        this.props.fetchUserInfo().then(res => {
            const {code} = res || {};
            if (code === 200) {
                const username = window.localStorage.getItem('username');
                if (!username) {
                    window.localStorage.setItem('username', res.data.name);
                }
                this.setState({
                    hasLogin: true
                });
            } else {
                // window.localStorage.clear();
                clearLocalStorage();
            }
        });
    }

    render() {
        const {userInfo} = this.props;
        const {hasLogin} = this.state;

        const loginUrl = ['/attest/pre', '/attest/step', '/appeal/step', '/user_center', '/mark'].some(item => {
        // let loginUrl = ['/attest/pre', '/attest/step', '/appeal/step', '/user_center'].some(item => {
            return window.location.href.indexOf(item) !== -1;
        });
        return (
            <div id="app">
                <Header userInfo={userInfo} hasLogin={hasLogin} />
                {!userInfo.code && loginUrl ? null : (
                    <div className="app-container">
                        <Switch>
                            <Route exact path={'/'} component={Home} />
                            <Route exact path={'/mark_err'} component={MarkErr} />
                            <Route exact path={'/num_err'} component={NumErr} />
                            <Route exact path={'/home/:type?'} component={Home} />
                            <Route exact path={'/attest/:type?'} component={Attest} />
                            <Route exact path={'/attests/:type?'} component={Attest} />
                            {/* <Route exact path={'/attest/pre'} component={PreAttest} /> */}
                            <Route exact path={'/attest/step/:num/:id?/:type?'} component={AttestStep} />
                            <Route exact path={'/call_auth'} component={CallAuth} />
                            <Route exact path={'/companyGuide'} component={CompanyGuide} />
                            {/* <Route exact path={'/appeal'} component={Appeal} /> */}
                            <Route exact path={'/appeal'} component={AppealMajor} />
                            <Route exact path={'/occupy'} component={AppealMajor} />
                            {/* <Route exact path={'/mark/:key?/:form?'} component={Mark} /> */}
                            <Route exact path={'/mark/:key?'} component={MarkMajor} />
                            {/* <Route exact path={'/mark_msg/:key?'} component={MarkMsg} /> */}
                            <Route exact path={'/verify_msg/:key?'} component={VerifyMsg} />
                            <Route exact path={'/help'} component={Help} />
                            <Route exact path={'/partner'} component={Partner} />
                            {/* <Route exact path={'/feedback'} component={Feedback} /> */}
                            <Route exact path={'/feedback'} component={FeedbackMajor} />
                            {/* <Route exact path={'/upgrade'} component={Upgrade} /> */}
                            <Route exact path={'/appeal/step/:num/:phone?/:id?/:type?'} component={ErrPage} />
                            <Route exact path={'/phoneSearch'} component={NormalLandPage} />
                            <Route exact path={'/yellow_page/:id?'} component={YellowPage} />
                            <Route exact path={'/user_center/:type'} component={UserCenter} />
                            <Route exact path={'/info_attest/:id?/:type?'} component={InfoAttest} />
                            <Route exact path={'/info_appeal/:id?/:type?'} component={InfoAppeal} />
                            <Route exact path={'/info_mark/:id?'} component={InfoMark} />
                            <Route exact path={'/business-card'} component={NewBusinessCard} />
                            <Route exact path={'/pz-card'} component={PzCard} />
                            <Route exact path={'/demo/:company?'} component={Demo} />
                            <Route exact path={'/location_page'} component={LocationPage} />
                            <Route path="*" component={Home}/>
                        </Switch>
                    </div>
                )}
                <Footer hasLogin={hasLogin} />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch: Function) {
    return {
        fetchUserInfo: () => fetchUserInfo(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
